export const SET_USER = "SET_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const SET_GENERATING_AI = "SET_GENERATING_AI";
export const UPDATE_USER_POINT = "UPDATE_USER_POINT";